<template>
  <div class="success-component">
    <QIcon name="icon-extra-smartphone" color="accent" size="100px" />
    <section>
      <h3>{{ $t("ETAB.PAGES.RECRUITMENT.ACTIVATION.@PERMANENT_SUCCESS_TITLE") }}</h3>
      <p>{{ $t("ETAB.PAGES.RECRUITMENT.ACTIVATION.@PERMANENT_SUCCESS_TEXT") }}</p>
    </section>
    <section>
      <h3>{{ $t("ETAB.PAGES.RECRUITMENT.ACTIVATION.@PERMANENT_EMAIL_TITLE") }}</h3>
      <p>{{ $t("ETAB.PAGES.RECRUITMENT.ACTIVATION.@PERMANENT_EMAIL_TEXT") }}</p>
    </section>
  </div>
</template>

<script>
export default {};
</script>
